import React, {useState} from 'react'
import CheckoutSteps from './CheckoutSteps';
import { useHistory } from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {saveShippingAddress} from '../redux/cart/cartActions';

const CheckoutShipping = () => {

  const {shippingAddress} = useSelector(state => state.cart)
  const {userInfo} = useSelector(state => state.userLogin)

  const history = useHistory()
  const dispatch = useDispatch()

  const [shippingAddressChanges, setShippingAddressChanges] = useState(shippingAddress);
  const {address, postalCode, city, country} = shippingAddressChanges;

  if(!userInfo) {
    history.push('/login')
  }

  const handleChange = (e) =>{
    setShippingAddressChanges({
      ...shippingAddressChanges, [e.target.name] : e.target.value
    })
  }

  const handleSubmit = (e) =>{
    e.preventDefault();
    dispatch(saveShippingAddress(shippingAddressChanges))
    history.push('/checkout/payment')
  }

  return (
    <div className="pageContainer">
      
      <CheckoutSteps step1 step2/>

        <div className="pageHeader">
            <p>Shipping Details</p>
        </div>

        <div className="pageBody">
            <form onSubmit={handleSubmit}>
              <div>
                  <label>Address</label>
                  <input type="text" placeholder="Enter Address" required 
                        name="address" value={address} onChange={handleChange}/>
              </div>

              <div>
                  <label>City</label>
                  <input type="text" placeholder="Enter City" required 
                        name="city" value={city} onChange={handleChange}/>
              </div>

              <div>
                  <label>PostalCode</label>
                  <input type="text" placeholder="Enter Postal Code" required 
                        name="postalCode" value={postalCode} onChange={handleChange}/>
              </div>

              <div>
                  <label>Country</label>
                  <input type="text" placeholder="Enter Country" required 
                        name="country" value={country} onChange={handleChange}/>
              </div>

              <button type="submit">Continue</button>
            </form>
        </div>
    </div>
  )
}

export default CheckoutShipping